//优惠券
const PlatformCoupon = () => import(/*webpackChunkName:'sale'*/"@/page/sale/coupon/platformCoupon/platformCoupon.vue")
const YardCoupon =()=>import(/*webpackChunkName:'sale'*/"@/page/sale/coupon/yardCoupon/yardCoupon.vue")
const UpdatePlatformCoupon = () => import(/*webpackChunkName:'sale'*/"@/page/sale/coupon/platformCoupon/components/UpdatePlatformCoupon/UpdatePlatformCoupon.vue")
const RouteTemp = () => import(/*webpackChunkName:'sale'*/'@/page/commons/routeTemp.vue')
export  const coupon={
        path: '/main/coupon',
        name: '优惠券',
        meta: {
            requireAuth: true,
        },
        component: RouteTemp,
        children: [{
            path: '/main/coupon/platform-coupon',
            name: '平台券',
            meta: {
                requireAuth: true,
            },
            component: PlatformCoupon
        },
        {
            path: '/main/coupon/update-platform-coupon',
            name: '添加/修改平台券',
            meta: {
                requireAuth: true,
            },
            component: UpdatePlatformCoupon
        },
        {
            path: '/main/coupon/yard-coupon',
            name: '车场券',
            meta: {
                requireAuth: true,
            },
            component: YardCoupon
        },
       ]
    }